







































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloSejour, getDefaultAloSejour } from '@/models/alo/AloSejour'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { AlsSejour } from '@/models/als/AlsSejour'

@Component({
  name: 'SejourList',
  props:{
    sejours:Array,
    loading:{
      type:Boolean,
      default:false
    }
  }
})
export default class SejourList extends Vue {
  private loading!:boolean
  

  private headers = [
    { text: 'Chambres', value: 'chambres'},    
    { text: 'Etat', value: 'sjrEnable' },
    { text: 'Client', value: 'user.libelle' },
    { text: 'Check in', value: 'sjrCheckIn', width:100 },
    { text: 'Check out', value: 'sjrCheckOut', width:100 },
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  private get sejourList() {
    return this.$store.myGetters.sejourList
  }

  private get search(){
    return this.$store.myGetters.searchSejour
  }

  isCheckIn(sejour:AloSejour){
    //@ts-ignore
    return this.$options.filters.formatDate(sejour.sjrCheckIn,"YYYY-MM-DD") == this.$options.filters.formatDate(new Date(),"YYYY-MM-DD")
  }

  isCheckOut(sejour:AloSejour){
    //@ts-ignore
    return this.$options.filters.formatDate(sejour.sjrCheckOut,"YYYY-MM-DD") == this.$options.filters.formatDate(new Date(),"YYYY-MM-DD")
  }


  private get sortDesc(){
    return this.$store.myGetters.sortSejourDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_SEJOUR_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortSejourBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_SEJOUR_BY(value)
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifySejour',params:{sejourId:item.id}})    
  }

  deleteSejour(sejour:AloSejour) {
     if(sejour.id != 0) {      
       this.$confirm(`${this.$t('Reception.AlertDelete')} "${sejour.user.libelle}" ?`,{title: this.$t('Global.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_SEJOUR_DELETE_REQUEST(sejour.id)
        } 
      })          
    } 
  }
 
}
